import {DocumentData} from "firebase/firestore";
import {LogisticsChangeLogType} from "./LogisticsDriverChangeLogType";
import {transportMillis} from "./transportValidation";

type Change = {changeType: LogisticsChangeLogType; previousValue: string; newValue: string};
const dayLabels: Record<string, string> = {WORKDAY: "Работен ден", HOLIDAY: "Отпуск", DAYOFF: "Отсъствие", SICK: "Болничен"};
const dateText = (value: number | null) => value === null ? "—" : new Date(value).toLocaleString("bg-BG", {
    timeZone: "Europe/Sofia", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit"
});

export function transportVehicleLabel(value: DocumentData): string {
    const name = value.truck?.name?.trim() || "";
    const plate = value.truck?.plate?.trim() || "";
    return `${value.isOwn !== false ? "Собствен" : "Външен"}: ${plate ? `${name} (${plate})` : name || "без избрано превозно средство"}`;
}

/** Diff actual persisted values, not UI events. Creation never calls this function. */
export function transportClientChanges(before: DocumentData, after: DocumentData, mode: "plan" | "report"): Change[] {
    const changes: Change[] = [];
    const add = (changeType: LogisticsChangeLogType, previousValue: string, newValue: string) => changes.push({changeType, previousValue, newValue});
    const dates = mode === "plan" ? [["startDate", "PLAN_START_DATE"], ["endDate", "PLAN_END_DATE"]] as const :
        [["reportStartDate", "REPORT_START_DATE"], ["reportEndDate", "REPORT_END_DATE"]] as const;
    for (const [field, type] of dates) {
        const oldValue = transportMillis(before[field]);
        const newValue = transportMillis(after[field]);
        if (oldValue !== newValue && (mode === "plan" || oldValue !== null)) add(type, dateText(oldValue), dateText(newValue));
    }
    if (mode === "plan") {
        if (before.driverId !== after.driverId) add("DRIVER", before.driverName || "", after.driverName || "");
        if ((before.isOwn ?? true) !== (after.isOwn ?? true) || ["id", "name", "plate"].some(field => (before.truck?.[field] || "") !== (after.truck?.[field] || ""))) {
            add("TRUCK", transportVehicleLabel(before), transportVehicleLabel(after));
        }
        const route = (value: DocumentData) => `${value.startPoint || "(празно)"} → ${value.endPoint || "(празно)"}`;
        if ((before.startPoint || "") !== (after.startPoint || "") || (before.endPoint || "") !== (after.endPoint || "")) add("ROUTE", route(before), route(after));
        if ((before.eventNumber || "") !== (after.eventNumber || "")) add("EVENT_NUMBER", before.eventNumber || "(празно)", after.eventNumber || "(празно)");
        const oldDay = before.dayType || "WORKDAY";
        const newDay = after.dayType || "WORKDAY";
        if (oldDay !== newDay) add("DAY_TYPE", dayLabels[oldDay] || oldDay, dayLabels[newDay] || newDay);
    } else {
        for (const [field, type] of [["startKm", "START_KM"], ["endKm", "END_KM"]] as const) {
            const previous = before[field] ?? 0;
            const next = after[field] ?? 0;
            if (previous !== 0 && previous !== next) add(type, `${previous} км`, next === 0 ? "—" : `${next} км`);
        }
        const oldNotes = before.reportNotes || "";
        const newNotes = after.reportNotes || "";
        if (oldNotes && oldNotes !== newNotes) add("REPORT_NOTES", oldNotes, newNotes || "—");
    }
    return changes;
}
